import React from "react";
import messages from "./messages";
import { injectIntl } from "react-intl";

class SuggestionsStory extends React.Component {
  constructor (props) {
    super(props);
    this.suggestionsContainer = React.createRef();
  }

  componentDidMount () {
    Notifications.setupSuggestions(this.suggestionsContainer.current, this.props.type);
  }

  render () {
    const type = this.props.type === "product_category" ? "productCategory" : this.props.type;
    const translatedType = this.props.intl.formatMessage(messages[`${type}Pluralization`]);
    const title = this.props.intl.formatMessage(
      messages.generalStoryTitle, {
        type: translatedType
      });
    return (
      <div
        className="myad-recommendations-widget"
        data-insights-category="myad-feed"
        data-insights-label="suggestion-story"
        data-insights-value={this.props.type}
      >
        <h2 className="afd-title-big afd-title-big--bmargin-big">
          {title}
        </h2>
        <div
          ref={this.suggestionsContainer}
          className={`afd-suggestions afd-suggestions--grid afd-suggestions-${type}`}
        />
      </div>
    );
  }
}

export default injectIntl(SuggestionsStory);
